<div class="">
    <form [formGroup]="addressForm">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4 col-xl-3">
                    <div class="form-group">
                        <sanabel-selectize appcode="1010" #countrySelectize required="false"
                            (clicked)="onCountryClicked($event)" formControlName="countryCode" [tabindex]="tabindex">
                        </sanabel-selectize>
                    </div>
                </div>


                <div class="col-12 col-sm-6 col-md-4 col-xl-3" [hidden]="!settingObj['address.govCode']?.display">
                    <div class="form-group">
                        <sanabel-selectize appcode="1009" #govSelectize required="false"
                            (clicked)="onGovClicked($event)" formControlName="govCode" [tabindex]="tabindex + 1">
                        </sanabel-selectize>
                    </div>
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-xl-3">
                    <div class="form-group">
                        <sanabel-selectize appcode="1011" #citySelectize required="false"
                            [SearchKeys]="{CountryCode:addressForm.get('countryCode').value}"
                            (clicked)="onCityClicked($event)" formControlName="cityCode" [tabindex]="tabindex + 2">
                        </sanabel-selectize>
                    </div>
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-xl-3" [hidden]="!settingObj['address.villageCode']?.display">
                    <div class="form-group">
                        <sanabel-selectize appcode="1012" #villageSelectize required="false"
                            (clicked)="onVillageClicked($event)" formControlName="villageCode"
                            [tabindex]="tabindex + 3">
                        </sanabel-selectize>
                    </div>
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-xl-3">
                    <div class="form-group">
                        <sanabel-selectize appcode="1013" #nationalitySelectize required="false"
                            (clicked)="onNatClicked($event)" formControlName="nationalityId" [tabindex]="tabindex + 4">
                        </sanabel-selectize>
                    </div>
                </div>



            </div>
            <div class="row" *ngIf="!FromHrEmployeesRegistration">
                <div class="col-12 col-sm">
                    <div class="form-group">
                        <label [ngClass]="{'small':smallInput}">{{'ArabicFullAddress' | translate}}</label>
                        <input class="form-control" type="text" formControlName="fullAddressAr"
                            [ngClass]="{'form-control-sm':smallInput}" />
                    </div>
                </div>

                <div class="col-12 col-sm">
                    <div class="form-group">
                        <label [ngClass]="{'small':smallInput}">{{'EnglishFullAddress'| translate}}</label>
                        <input class="form-control" type="text" formControlName="fullAddressEn"
                            [ngClass]="{'form-control-sm':smallInput}" />
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="FromHrEmployeesRegistration">
                <div class="col-3 ">
                    <div class="form-group">
                        <label [ngClass]="{'small':smallInput}">{{'NEIGHBORHOOD' | translate}}</label>
                        <input class="form-control" type="text" formControlName="neighborhood"
                            [ngClass]="{'form-control-sm':smallInput}" />
                    </div>
                </div>

                <div class="col-3 ">
                    <div class="form-group">
                        <label [ngClass]="{'small':smallInput}">{{'BUILDINGNUMBER'| translate}}</label>
                        <input class="form-control" type="text" formControlName="buildingNumber"
                            [ngClass]="{'form-control-sm':smallInput}" />
                    </div>
                </div>
                <div class="col-3 ">
                    <div class="form-group">
                        <label [ngClass]="{'small':smallInput}">{{'FLOORNO'| translate}}</label>
                        <input class="form-control" type="text" formControlName="floorNo"
                            [ngClass]="{'form-control-sm':smallInput}" />
                    </div>
                </div>
            </div>
        </div>

    </form>

</div>